import React, { useState, useEffect } from "react";
import axiosMain from "../http/axiosMain";
import {
  Box,
  Typography,
  Button,
  Grid,
  Card,
  CardContent,
  Tabs,
  Tab,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  IconButton,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Check } from "lucide-react";
import CloseIcon from "@mui/icons-material/Close";

export default function SubScriPtionMethod() {
  const navigate = useNavigate();

  const [roleType, setRoleType] = useState("brand");
  const [subscriptionPlans, setSubscriptionPlans] = useState([]);
  const [activeTab, setActiveTab] = useState("brand");
  const [openModal, setOpenModal] = useState(false);
  const [loading, setLoading] = useState(false);

  // callback form state
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    email: "",
    subject: "",
    message: "",
  });

  const fetchPlans = async () => {
    try {
      const roleId = roleType === "brand" ? 1 : 2;
      const response = await axiosMain.get(
        `/api/subscription/subscription-plan?role_id=${roleId}`
      );
      if (response.data.status) {
        setSubscriptionPlans(response.data.data);
      }
    } catch (error) {
      console.error("Failed to fetch subscription plans", error);
    }
  };

  useEffect(() => {
    fetchPlans(activeTab);
  }, [activeTab]);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
    setRoleType(newValue);
  };

  // handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // submit request callback form
  const handleSubmit = async () => {
    try {
      setLoading(true);
      const response = await axiosMain.post(
        "/api/request-call-back/requestcallback",
        formData
      );

      if (response.data.status) {
        console.log("Request submitted successfully");
        setOpenModal(false);
        setFormData({
          name: "",
          mobile: "",
          email: "",
          subject: "",
          message: "",
        });
      } else {
        console.log("Something went wrong....");
      }
    } catch (error) {
      console.error("Error submitting request callback:", error);
      alert("Failed to submit request");
    } finally {
      setLoading(false);
    }
  };

  const getPrice = (plan) => {
    const price = plan.monthly_price;
    if (plan.flag_discount_active) {
      const discounted = price - (price * plan.discount) / 100;
      return {
        original: price,
        discounted: Math.round(discounted),
      };
    }
    return { original: price, discounted: null };
  };

  const getButtonText = (planType) => {
    if (planType === "Starter") return "Start Starter Plan";
    if (planType === "Plus") return "Upgrade to Plus";
    if (planType === "Pro") return "Upgrade to Pro";
    return "Subscribe";
  };

  const renderCard = (plan) => {
    const { original, discounted } = getPrice(plan);
    return (
      <Box
        sx={{
          px: 3,
          py: 4,
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          height: "100%",
        }}
        key={plan.subscription_id}
      >
        <Typography
          variant="h6"
          fontWeight="500"
          gutterBottom
          sx={{ fontFamily: "Poppins, sans-serif" }}
        >
          {plan.plan_type}
        </Typography>

        <Box display="flex" flexDirection="column" gap={1} mb={2}>
          {discounted !== null ? (
            <Typography
              variant="body2"
              sx={{
                color: "#a1a1a1",
                textDecoration: "line-through",
                fontWeight: 500,
                fontFamily: "Inter",
              }}
            >
              ₹{original}
            </Typography>
          ) : (
            <Typography sx={{ height: "18px" }}></Typography>
          )}

          <Box display="flex" alignItems="center" gap={1}>
            <Typography
              variant="h5"
              sx={{
                fontWeight: 700,
                fontFamily: "Poppins,sans-serif",
                color: "#000",
              }}
            >
              ₹{discounted !== null ? discounted : original}
            </Typography>

            {discounted !== null && (
              <Typography
                variant="caption"
                sx={{
                  backgroundColor: "#f5f5f5",
                  color: "#000",
                  fontWeight: 600,
                  px: 1,
                  borderRadius: "4px",
                  fontSize: "12px",
                }}
              >
                -{plan.discount}%
              </Typography>
            )}
          </Box>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 1.2,
            mt: 2,
            flexGrow: 1,
          }}
        >
          {plan.features &&
            plan.features.map((feature, index) => (
              <Box
                key={index}
                sx={{ display: "flex", alignItems: "flex-start", gap: 1 }}
              >
                <Box
                  sx={{
                    mt: "2px",
                    width: 16,
                    height: 16,
                    borderRadius: "2px",
                    backgroundColor: "#f5f5f5",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  <Check color="#6B8E76" size={20} />
                </Box>
                <Typography
                  variant="body2"
                  sx={{
                    fontFamily: "Inter",
                    wordBreak: "break-word",
                    flex: 1,
                  }}
                >
                  {feature}
                </Typography>
              </Box>
            ))}
        </Box>

        <Box mt="auto" pt={3}>
          <Button
            fullWidth
            variant="outlined"
            sx={{
              color: "#6B8E76",
              fontWeight: 500,
              fontSize: "14px",
              borderRadius: "8px",
              textTransform: "none",
              fontFamily: "Poppins,sans-serif",
              py: 1.2,
              borderColor: "#6B8E76 !important",
              backgroundColor: "transparent",
            }}
            onClick={() => navigate("/login")}
          >
            {getButtonText(plan.plan_type)}
          </Button>
        </Box>
      </Box>
    );
  };

  return (
    <Box sx={{ p: 4 }}>
      <Card
        sx={{
          maxWidth: "90%",
          mx: "auto",
          boxShadow: 0,
          borderRadius: 2,
        }}
      >
        <CardContent>
          <Box sx={{ borderBottom: "1px solid #DDDDDD" }}>
            <Tabs
              value={activeTab}
              onChange={handleTabChange}
              TabIndicatorProps={{
                style: {
                  backgroundColor: "#6B8E76",
                  height: "2px",
                },
              }}
              sx={{
                "& .MuiTabs-flexContainer": {
                  justifyContent: "center",
                },
                "& .MuiTab-root": {
                  textTransform: "none",
                  fontFamily: "Poppins",
                  fontWeight: 500,
                  fontSize: "14px",
                  color: "#49454F",
                },
                "& .Mui-selected": {
                  color: "#1D1B20 !important",
                },
              }}
            >
              <Tab label="Brand" value="brand" />
              <Tab label="Influencer" value="influencer" />
            </Tabs>
          </Box>

          <Box textAlign="center" mt={4}>
            <Typography
              variant="h5"
              fontWeight="bold"
              gutterBottom
              sx={{
                color: "#000000",
                fontFamily: '"Poppins",sans-serif',
                fontWeight: "600",
                fontSize: "24px",
              }}
            >
              Subscribe to Get More Feature
            </Typography>
            <Typography
              variant="body1"
              mb={3}
              pb={5}
              sx={{
                color: "#656565",
                fontFamily: '"Poppins",sans-serif',
                fontWeight: "500",
                fontSize: "18px",
              }}
            >
              Choose Plan That Suits You Best!
            </Typography>
          </Box>

          <Grid
            container
            justifyContent="center"
            sx={{
              border: "0.85px solid #e0e0e0",
              borderRadius: "12px",
              overflow: "hidden",
            }}
          >
            {subscriptionPlans.map((plan, index) => (
              <Grid
                item
                xs={12}
                sm={4}
                key={plan.subscription_id}
                sx={{
                  borderRight:
                    index !== subscriptionPlans.length - 1
                      ? "0.85px solid #e0e0e0"
                      : "none",
                }}
              >
                {renderCard(plan)}
              </Grid>
            ))}
          </Grid>

          {/* Bottom Help Box */}
          <Box
            sx={{
              mt: 5,
              border: "1px solid #E0E0E0",
              borderRadius: "12px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              px: 3,
              py: 2,
              backgroundColor: "#fff",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <Box
                sx={{
                  width: 40,
                  height: 40,
                  borderRadius: "50%",
                  backgroundColor: "#f5f5f5",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <span style={{ fontSize: "20px", color: "black" }}>🎧</span>
              </Box>

              <Box>
                <Typography
                  variant="subtitle1"
                  fontWeight="600"
                  sx={{
                    fontFamily: "Poppins, sans-serif",
                    color: "#000",
                  }}
                >
                  Have Some Query About Subscription Plans?
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: "#656565",
                    fontFamily: "Inter, sans-serif",
                  }}
                >
                  Leave your contact details for customized solutions.
                </Typography>
              </Box>
            </Box>

            <Button
              variant="outlined"
              sx={{
                borderRadius: "8px",
                textTransform: "none",
                fontFamily: "Poppins, sans-serif",
                fontWeight: 500,
                color: "#6B8E76",
                borderColor: "#6B8E76",
                px: 3,
                py: 1,
              }}
              onClick={() => setOpenModal(true)} // 👈 open modal
            >
              Request a Call Back
            </Button>
          </Box>
        </CardContent>
      </Card>

      {/* Modal 👇 */}
      <Dialog
        open={openModal}
        onClose={() => setOpenModal(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "12px",
            p: 1,
          },
        }}
      >
        <DialogTitle
          sx={{
            textAlign: "center",
            fontWeight: 600,
            fontSize: "20px",
            position: "relative",
          }}
        >
          Connect With Us
          <IconButton
            onClick={() => setOpenModal(false)}
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent>
          <Box
            sx={{
              border: "1px solid #e0e0e0",
              borderRadius: "10px",
              p: 3,
            }}
          >
            <Grid container spacing={2}>
              {/* Name */}
              <Grid item xs={12} md={6}>
                <TextField
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  fullWidth
                  placeholder="Enter Your Name"
                  variant="outlined"
                  size="small"
                />
              </Grid>

              {/* Mobile Number */}
              <Grid item xs={12} md={6}>
                <TextField
                  name="mobile"
                  value={formData.mobile}
                  onChange={handleChange}
                  fullWidth
                  placeholder="Enter Your Mobile Number"
                  variant="outlined"
                  size="small"
                />
              </Grid>

              {/* Email */}
              <Grid item xs={12} md={6}>
                <TextField
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  fullWidth
                  placeholder="Enter Your Email"
                  variant="outlined"
                  size="small"
                />
              </Grid>

              {/* Subject */}
              <Grid item xs={12} md={6}>
                <TextField
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  fullWidth
                  placeholder="Enter Your Subject"
                  variant="outlined"
                  size="small"
                />
              </Grid>

              {/* Message */}
              <Grid item xs={12}>
                <TextField
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  fullWidth
                  placeholder="Enter Your Message"
                  variant="outlined"
                  size="small"
                  multiline
                  rows={4}
                />
              </Grid>
            </Grid>

            {/* Submit Button */}
            <Box textAlign="center" mt={3}>
              <Button
                variant="contained"
                sx={{
                  backgroundColor: "#6B8E76",
                  borderRadius: "6px",
                  textTransform: "none",
                  px: 4,
                  "&:hover": {
                    backgroundColor: "#5c7c67",
                  },
                }}
                onClick={handleSubmit}
                disabled={loading}
              >
                {loading ? "Submitting..." : "Submit"}
              </Button>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>
    </Box>
  );
}
